import { render, staticRenderFns } from "./ImageBlock.vue?vue&type=template&id=6bbfe79b&"
import script from "./ImageBlock.vue?vue&type=script&lang=js&"
export * from "./ImageBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports